// extracted by mini-css-extract-plugin
export default {"wrapper":"NextTaskForm_wrapper__rCXu+","task-form-wrapper":"NextTaskForm_task-form-wrapper__KAIs6","task-title":"NextTaskForm_task-title__TyWfj"};